/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Checkbox,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  HStack,
  Text,
  Textarea,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import AppColors from '../../../../constants/AppColors';
import { SortDownIcon, SortUpIcon, XIconGray } from '../../../../constants/IconData';
import { AuditSheetContext } from '../../../../providers/AuditSheetProvider';
import CommentList from './CommentList';
import CommentSaveButton from './CommentSaveButton';
import { useParams } from 'react-router-dom';

function NotesActivityDrawer({ 
  isOpen, 
  onClose, 
  onOpenNotes, 
  argBatchId 
}) {
  const [notes, setNotes] = useState('');
  const [isInternal, setIsInternal] = useState(false);
  const auditSheetContext = useContext(AuditSheetContext);
  const { batchId: paramBatchId } = useParams();
  const batchId = paramBatchId || argBatchId;

  const {
    currentUpload,
    allComments,
    setAllComments,
    postComment,
    isPostCommentLoading,
    getAllComments,
    commentFilters,
    setCommentFilters,
    totalComments,
    isAllCommentLoading,
  } = auditSheetContext;

  const addNotes = async () => {
    const body = {
      parent: null,
      audit_sheet_columns: [],
      audit_sheet_rows: [],
      action: Object.keys(currentUpload || {}).length ? 'OPEN' : 'BATCH NOTES',
      comment: notes,
      notes: true,
      chart: currentUpload.id,
      tagged_user: [],
      batch: batchId,
      is_internal: isInternal,
    };
    const response = await postComment(body);
    setAllComments(prev => [...prev, { ...response }]);
    setNotes('');
    setIsInternal(false);
  };

  const getComment = async () => {
    const res = await getAllComments();
    if (Array.isArray(res) && commentFilters.page > 1) {
      setAllComments(prev => [...prev, ...res]);
    }
  };

  useEffect(() => {
    if (Object.keys(commentFilters).length) {
      getComment();
    }
  }, [commentFilters]);

  const drawerRef = useRef();

  const onScroll = () => {
    if (drawerRef.current && !isAllCommentLoading) {
      const { scrollTop, scrollHeight, clientHeight } = drawerRef.current;

      if (Math.floor(scrollTop) + clientHeight >= scrollHeight) {
        setCommentFilters(prev => {
          if (Math.ceil(totalComments / 10) >= prev.page + 1) {
            return { ...prev, page: prev.page + 1 };
          }
          return prev;
        });
      }
    }
  };

  return (
    <>
      <Drawer onClose={onClose} isOpen={isOpen} size={'sm'}>
        <DrawerContent>
          <DrawerHeader bg={AppColors.primary}>
            <HStack justifyContent={'space-between'}>
              <HStack>
                <XIconGray
                  onClick={onClose}
                  style={{ color: AppColors.white, cursor: 'pointer' }}
                />
                <Text fontWeight={900} paddingLeft={4} color={AppColors.white}>
                  Notes and Activity
                  <Text as="span" fontWeight={500} fontSize="sm" display="block">
                  {batchId}
                  </Text>
                </Text>
              </HStack>
              <Button
                fontSize={'sm'}
                bg={'rgba(0,0,0,0.05)'}
                color={'white'}
                fontWeight='normal'
                _hover={{ bg: 'rgba(255,255,255,0.15)' }}
                _active={{ bg: 'rgba(0,0,0,0.15)' }}
                onClick={() =>
                  setCommentFilters(prev => ({
                    ...prev,
                    reverse: !prev.reverse,
                    page: 1,
                  }))
                }
              >
                Sort by {commentFilters.reverse ? <SortUpIcon /> : <SortDownIcon />}
              </Button>
            </HStack>
          </DrawerHeader>

          <DrawerBody ref={drawerRef} onScroll={onScroll}>
            <CommentList onOpenNotes={onOpenNotes} batchId={batchId} />
          </DrawerBody>

          <DrawerFooter>
            <Box width={'100%'}>
              <Textarea
                name='notes'
                value={notes}
                onChange={e => {
                  setNotes(e.target.value);
                }}
                placeholder='Add notes....'
              />
              <Checkbox
                size='sm'
                colorScheme='purple'
                mt={1}
                isChecked={isInternal}
                onChange={e => setIsInternal(e.target.checked)}
              >
                <Text fontSize='xs' color='gray.500'>Mark Internal</Text>
              </Checkbox>
              {notes ? (
                <CommentSaveButton
                  onSave={addNotes}
                  onCancel={() => setNotes('')}
                  saveButtonText='Send'
                  isLoading={isPostCommentLoading}
                />
              ) : null}
            </Box>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default NotesActivityDrawer;
